<script>
import BotoesNavegacao from '@/components/BotoesNavegacao.vue'
import { validarCpfCnpj } from '@/utils/cpfCnpj'

export default {
  components: { BotoesNavegacao },

  props: {
    form: { type: Object, required: true },
  },

  computed: {
    personNumberMask() {
      return this.form.person_type === 'pj' ? '##.###.###/####-##' : '###.###.###-##'
    },
    nomeRazaoLabel() {
      return this.form.person_type === 'pj' ? 'Razão social' : 'Nome completo'
    },
  },

  methods: {
    setPersonType(type) {
      if (this.form.person_type !== type) {
        this.form.person_type = type
        this.form.person_number = ''
        if (type === 'pj') {
          this.form.nacionalidade = ''
          this.form.estado_civil = ''
        }
      }
    },
    avancar() {
      const doc = (this.form.person_number || '').replace(/\D/g, '')
      const esperado = this.form.person_type === 'pj' ? 14 : 11

      if (!this.form.nome || this.form.nome.trim().length < 3) {
        this.$toast.error('Informe seu nome completo.')
        return
      }
      if (doc.length !== esperado) {
        this.$toast.error(this.form.person_type === 'pj'
          ? 'Informe o CNPJ completo (14 dígitos).'
          : 'Informe o CPF completo (11 dígitos).')
        return
      }
      if (!validarCpfCnpj(doc)) {
        this.$toast.error('CPF/CNPJ inválido. Confira os dígitos.')
        return
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.form.email || '').trim())) {
        this.$toast.error('Informe um e-mail válido.')
        return
      }
      const tel = (this.form.telefone || '').replace(/\D/g, '')
      if (tel.length < 10) {
        this.$toast.error('Informe o celular com DDD.')
        return
      }
      if (this.form.person_type === 'pf' && !this.form.data_nascimento) {
        this.$toast.error('Informe a data de nascimento.')
        return
      }
      if (this.form.person_type === 'pf' && !this.form.nacionalidade) {
        this.$toast.error('Informe a nacionalidade.')
        return
      }
      if (this.form.person_type === 'pf' && !this.form.estado_civil) {
        this.$toast.error('Selecione o estado civil.')
        return
      }
      this.$emit('avancar')
    },
  },
}
</script>

<template>
  <div>
    <div class="form-row">
      <label class="field-label">Você é pessoa física ou jurídica?</label>
      <div class="toggle-group">
        <button
          type="button"
          class="toggle-group__btn"
          :class="{ 'toggle-group__btn--active': form.person_type === 'pf' }"
          @click="setPersonType('pf')"
        >Pessoa física</button>
        <button
          type="button"
          class="toggle-group__btn"
          :class="{ 'toggle-group__btn--active': form.person_type === 'pj' }"
          @click="setPersonType('pj')"
        >Pessoa jurídica</button>
      </div>
    </div>

    <div class="form-row">
      <label class="field-label">{{ nomeRazaoLabel }}</label>
      <input v-model="form.nome" type="text" class="input" :placeholder="nomeRazaoLabel" />
    </div>

    <div class="form-row">
      <label class="field-label">{{ form.person_type === 'pj' ? 'CNPJ' : 'CPF' }}</label>
      <input
        v-model="form.person_number"
        v-mask="personNumberMask"
        type="text"
        class="input"
        :placeholder="form.person_type === 'pj' ? '00.000.000/0000-00' : '000.000.000-00'"
        inputmode="numeric"
      />
    </div>

    <template v-if="form.person_type === 'pf'">
      <div class="form-row">
        <label class="field-label">Data de nascimento</label>
        <input
          v-model="form.data_nascimento"
          v-mask="'##/##/####'"
          type="text"
          class="input"
          placeholder="DD/MM/AAAA"
          inputmode="numeric"
        />
      </div>
    </template>

    <div class="form-row">
      <label class="field-label">Celular</label>
      <input
        v-model="form.telefone"
        v-mask="'(##) #####-####'"
        type="tel"
        class="input"
        placeholder="(11) 90000-0000"
        inputmode="tel"
      />
    </div>

    <div class="form-row">
      <label class="field-label">E-mail</label>
      <input v-model="form.email" type="email" class="input" placeholder="seu@email.com" inputmode="email" />
    </div>

    <template v-if="form.person_type === 'pf'">
      <div class="form-row">
        <label class="field-label">Nacionalidade</label>
        <input v-model="form.nacionalidade" type="text" class="input" placeholder="Brasileira" />
      </div>
      <div class="form-row">
        <label class="field-label">Estado civil</label>
        <select v-model="form.estado_civil" class="select">
          <option value="">Selecione...</option>
          <option value="solteiro">Solteiro(a)</option>
          <option value="casado">Casado(a)</option>
          <option value="divorciado">Divorciado(a)</option>
          <option value="viuvo">Viúvo(a)</option>
          <option value="uniao_estavel">União estável</option>
          <option value="separado">Separado(a)</option>
        </select>
      </div>
    </template>

    <BotoesNavegacao @voltar="$emit('voltar')" @avancar="avancar" />
  </div>
</template>
